var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"markerInfoWindow"},on:{"click":_vm.openAccommodation}},[_c('img',{staticClass:"photo",attrs:{"src":_vm.imageUrl}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.accommodationName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }